export const PHONE_COUNTRIES = [
  { country: 'US', code: '1', label: '🇺🇸 +1', accessibleLabel: 'USA +1' },
  { country: 'CA', code: '1', label: '🇨🇦 +1', accessibleLabel: 'Canada +1' },
  { country: 'IN', code: '91', label: '🇮🇳 +91', accessibleLabel: 'India +91' },
];
export const compactPhone = value => String(value || '').trim().replace(/[\s().-]/g, '');
export function phoneCountry(value, preferred = 'US') {
  const phone = compactPhone(value);
  if (phone.startsWith('+91')) return 'IN';
  if (phone.startsWith('+1')) return preferred === 'CA' ? 'CA' : 'US';
  return phone.startsWith('+') ? '' : preferred;
}
export function nationalPhone(value) {
  const phone = compactPhone(value);
  if (phone.startsWith('+91')) return phone.slice(3);
  if (phone.startsWith('+1')) return phone.slice(2);
  return String(value || '');
}
export function internationalPhone(value, country) {
  const phone = compactPhone(value);
  if (!phone || phone.startsWith('+')) return phone;
  const code = PHONE_COUNTRIES.find(item => item.country === country)?.code;
  if (!code) return phone;
  // Accept a pasted dialing prefix without adding it a second time.
  if (phone.startsWith(code) && phone.length === code.length + 10) return `+${phone}`;
  return `+${code}${phone}`;
}
